import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import { api, setToken, clearToken, getToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        (async () => {
            if (!getToken()) {
                setLoading(false);
                return;
            }
            try {
                const { user } = await api.me();
                if (active) setAdmin(user);
            } catch {
                clearToken();
            } finally {
                if (active) setLoading(false);
            }
        })();
        return () => {
            active = false;
        };
    }, []);

    const login = useCallback(async (email, password) => {
        const { token, user } = await api.login(email, password);
        setToken(token);
        setAdmin(user);
        return user;
    }, []);

    const logout = useCallback(() => {
        clearToken();
        setAdmin(null);
    }, []);

    return (
        <AuthContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
